export interface EnvironmentVariable {
  id: string;
  service_name: string;
  service_type: number;
  provider: string;
  secret_key: string | null;
  mode_type: number;
  changed_by_id: string | null;
  changed_at: string | null;
  created_at: string;
  updated_at: string;
}

export enum ModeType {
  ENABLED = 1,
  DISABLED = 2,
}

export interface EnvironmentVariablesResponse {
  status: boolean;
  message: string;
  data: EnvironmentVariable[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface EnvironmentVariablesParams {
  search?: string;
  page?: number;
  limit?: number;
}

export enum ExternalServiceType {
  STRIPE_PUBLIC_KEY = 1,
  STRIPE_SECRET_KEY = 2,
  STRIPE_WEBHOOK_SECRET = 3,
  NEXT_STRIPE_PUBLISHABLE_KEY = 4,
  VITE_STRIPE_PUBLISHABLE_KEY = 5,
  PAYTRAIL_BASE_URL = 6,
  PAYTRAIL_MERCHANT_ID = 7,
  PAYTRAIL_SECRET = 8,
  AIS_STREAM_API_KEY = 9,
  AIS_STREAM_WEBSOCKET_URL = 10,
  NETVISOR_CUSTOMER_ID = 11,
  NETVISOR_CUSTOMER_KEY = 12,
  NETVISOR_PARTNER_ID = 13,
  NETVISOR_PARTNER_KEY = 14,
  NETVISOR_BASE_URL = 15,
  NETVISOR_SENDER = 16,
  NETVISOR_ORGANISATION_ID = 17,
  JIRA_BASE_URL = 18,
  JIRA_PROJECT_KEY = 19,
  JIRA_EMAIL = 20,
  JIRA_API_TOKEN = 21,
  JIRA_SERVICE_DESK_ID = 22,
  JIRA_REQUEST_TYPE_ID_BUG = 23,
  JIRA_REQUEST_TYPE_ID_QUESTION = 24,
  JIRA_REQUEST_TYPE_ID_REQUEST = 25,
  JIRA_REQUEST_TYPE_ID_DEFAULT = 26,
  DEEP_LANGUAGE_KEY = 27,
  VITE_GOOGLE_MAPS_API_KEY = 28,
  NEXT_PUBLIC_GOOGLE_MAPS_API_KEY = 29,
  VITE_PUBLIC_MAPBOX_ACCESS_TOKEN = 30,
  NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN = 31,
  STRIPE_PAYMENT_OPTION = 32,
  PAYTRAIL_PAYMENT_OPTION = 33,
}
